import React, {useEffect} from 'react';
import {useAuth, useDarkMode} from "../../../context";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, Stack} from "react-bootstrap";
import {AdminUserAlert, PageTitle, SelectText, SingleText} from "../../_components";
import {Formik, Form as FormikForm, useFormikContext} from "formik";
import {WhiteCard} from "../_components/WhiteCard";
import onDark from "../icons/case_on_dark.svg"
import offDark from "../icons/case_off_dark.svg"
import impulseDark from "../icons/case_impulse_dark.svg"
import onLight from "../icons/case_on_light.svg"
import offLight from "../icons/case_off_light.svg"
import impulseLight from "../icons/case_impulse_light.svg"
import {RelayAction} from "../../../utils2/maps";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";
import {ProgressSteps} from "../_components/ProgressSteps";
import {GoBackConfig} from "../_components/GoBackConfig";
import {ABBreadcrumbs} from "../_components/ABBreadcrumbs";

export function AddEditRelay({index}) {
    const {uid,  rid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (rid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location, rid])

    if (location.state) {
        return <AddEditRelayInt index={index}/>
    }
    return null
}

function AddEditRelayInt({index}){
    const {authToken} = useAuth()
    const {uid, did, rid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const currentStep = location.state.currentStep

    const edit = rid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(rid === "new" ? null : endpoints.event.get(rid), authToken?.jwt)
    const event = ev?.data
    const config2 = event?.config2

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.add(did), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(rid), authToken?.jwt)

    const validationSchema = yup.object().shape({
        duration: yup.number().typeError("Duration must be a valid number").required("Duration is required").min(1, "Duration must be at least 1")
            .max(60, "Duration must be at most 60")
            .test("duration-required-for-impulse", "Duration is required for impulse action", function (value) {
                const {action} = this.parent
                if (action === "impulse") {
                    return typeof value === "number" && !isNaN(value);
                }
                return true; // Skip this test if action is not 'impulse'
            })
    })

    const initialValues = {
        // Relay
        // enable: relay?.enable || true,
        action: location.state?.relay?.action || config2?.action || 1,
        duration: location.state?.relay?.duration || config2?.duration || 5,
        index: location.state?.relay?.index || index
    }

    function handleOnSubmit(values, action) {
        const payload = {...location.state, name: location.state?.name || event?.name, relay: values}

        if (currentStep === location.state.steps.length - 1 && !edit) {
            submitFormAdd(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(location.state.steps[0])
            })
        } else if (edit) {
            submitFormEdit(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            navigate(location.state.steps[currentStep + 1], {state: {...location.state, ...payload}})
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }


    return <Stack>
        <AdminUserAlert/>
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>

        <ABBreadcrumbs breadcrumbList={[
            {name: "Your devices", shortName:"Devices", to: `/device/${uid}`},
            {name: "Configure Device", shortName:"Configure", to: `/device/${uid}/${did}/config`},
            {name:"Relay"}]}
        />

        <PageTitle title={`Set Relay ${index}`}>{edit ? `Edit ${event?.name}` : `Add`}.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, values, errors, touched}) => (
                <FormikForm>

                    <ProgressSteps steps={location.state.steps.slice(1)} currentStep={currentStep}
                                   state={{...location.state, name: location.state?.name || event?.name, relay: values}} edit={edit}/>

                    <RelaySet title={index}/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        {/*<Button variant="link" onClick={backTo}>Go back</Button>*/}
                        <GoBackConfig state={{...location.state, name: location.state?.name || event?.name, relay: values}} edit={edit}/>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Save</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>

    </Stack>

}

function RelaySet({title}) {
    const {values} = useFormikContext()

    const relayActivation = [
        {id: 0, name: "Disabled", variant: "outline-secondary", disabled: false, icon: "bi bi-ban"},
        {id: 1, name: "Enabled", variant: "success", disabled: false, icon: "bi bi-check2"},
    ]

    const actions = [
        {id: 0, name: RelayAction.find(item => item.id === 0).name, disable: true},
        {id: 1, name: RelayAction.find(item => item.id === 1).name, disable: false},
        {id: 2, name: RelayAction.find(item => item.id === 2).name, disable: false},
    ]
    return <div>
        <WhiteCard>
            <div className="d-flex align-items-center justify-content-between gap-2">
                {/*<div className="fs-6 fw-semibold">{`Relay ${title}`}</div>*/}
                {/*<SingleToggleText name="enable" label="" items={relayActivation}/>*/}
                <SelectText name="action" label="Action" disabled={values?.enable === 0}>
                    {actions.map(item => (
                        <option key={item.id} value={item.id} disabled={item.disable}>{item.name}</option>
                    ))}
                </SelectText>
                {/*{values.action === actions.find(a => a.id === 2)?.name &&*/}
                <ABOverlayTooltip tip="Time interval with Relay On"><span><SingleText name="duration" label="Impulse duration" postfix="sec"
                                                                                      disabled={values.action !== actions.find(a => a.id === 2)?.name}/></span></ABOverlayTooltip>
                {/*}*/}
            </div>
        </WhiteCard>

        <ChartDescription/>

        {/*<SelectText name="controlled_by_id" label="Select relay">*/}
        {/*    <option value="">None</option>*/}
        {/*    {deviceRelay.map((item, index) => (*/}
        {/*        <option key={index} value={index}>{item.name}</option>*/}
        {/*    ))}*/}
        {/*</SelectText>*/}
    </div>
}

function ChartDescription() {
    const {darkMode} = useDarkMode()
    const {values} = useFormikContext()

    const on = RelayAction.find(item => item.id === 1)
    const off = RelayAction.find(item => item.id === 0)
    const impulse = RelayAction.find(item => item.id === 2)

    if (!on || !off || !impulse || values.action == null) return null

    const actionId = Number(values.action)
    const isOn = actionId === on.id
    const isOff = actionId === off.id
    const isImpulse = actionId === impulse.id

    if (darkMode) {
        if (isOn) return <img src={onLight} alt="Relay actions" />
        if (isOff) return <img src={offLight} alt="Relay actions" />
        if (isImpulse) return <img src={impulseLight} alt="Relay actions" />
    } else {
        if (isOn) return <img src={onDark} alt="Relay actions" />
        if (isOff) return <img src={offDark} alt="Relay actions" />
        if (isImpulse) return <img src={impulseDark} alt="Relay actions" />
    }
    return null


    // if (darkMode) {
    //     if (values.action === String(RelayAction.find(item => item.id === 1).id)) {
    //         return <img src={onLight} alt="Relay actions"/>
    //     } else if (values.action === String(RelayAction.find(item => item.id === 0).id)) {
    //         return <img src={offLight} alt="Relay actions"/>
    //     } else if (values.action === String(RelayAction.find(item => item.id === 2).id)) {
    //         return <img src={impulseLight} alt="Relay actions"/>
    //     }
    // } else {
    //     if (values.action === String(RelayAction.find(item => item.id === 1).id)) {
    //         return <img src={onDark} alt="Relay actions"/>
    //     } else if (values.action === String(RelayAction.find(item => item.id === 0).id)) {
    //         return <img src={offDark} alt="Relay actions"/>
    //     } else if (values.action === String(RelayAction.find(item => item.id === 2).id)) {
    //         return <img src={impulseDark} alt="Relay actions"/>
    //     }
    // }
}